import { CommonModule } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { UserService } from '../../../service/user.service';

@Component({
  selector: 'app-email-notifications-setting',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './email-notifications-setting.component.html',
  styleUrl: './email-notifications-setting.component.scss',
})
export class EmailNotificationsSettingComponent {
  #userService = inject(UserService);

  control = input.required<FormControl<boolean>>();

  constructor() {
    effect(() => {
      const ctrl = this.control();
      const enabled = this.#userService.settings()?.notificationsEmail ?? true;
      ctrl?.setValue(enabled, { emitEvent: false });
    });
  }
}
